import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
  @media (max-width: 767px) {
    padding: 0px 0px 72px;
  }
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  min-height: calc(100vh - 136px);
  height: fit-content;
  padding: 0 15px 15px;
  width: 100%;
  max-width: 570px;
  margin: auto;
`;

export const Title = styled.div`
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  color: ${({ theme }) => theme.colors.textLight};
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.textLight};
  margin: 30px 0 20px;
  & span {
    display: block;
    width: fit-content;
    border-bottom: 2px solid ${({ theme }) => theme.colors.textLight};
  }
`;

export const Card = styled.div`
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.32);
  border-radius: 4px;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: left;
  padding: 15px 20px;
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  gap: 15px;
  position: relative;
  div {
    display: flex;
    width: fit-content;
    justify-content: center;
    align-items: center;
    svg.download {
      fill: ${({ theme }) => theme.colors.main};
      box-sizing: content-box;
      padding: 9px;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      border: 1px solid ${({ theme }) => theme.colors.main};
    }
  }
  @media (max-width: 570px) {
    flex-direction: column;
    div {
      width: 100%;
    }
  }
`;
